import * as React from "react";
import { SVGProps } from "react";

const Elastos = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 94 78" {...props}>
    <path
      fill="#2a3d58"
      d="m47.015 40.797 23.507-13.572-23.507-13.653v27.225z"
    />
    <path
      fill="#0f2631"
      d="M47.015 40.797 23.507 27.225l23.508-13.653v27.225zM70.522 0 47.015 13.572l23.507 13.653V0z"
    />
    <path fill="#2a3d58" d="M70.522 0 94.03 13.572 70.522 27.225V0z" />
    <path fill="#0f2631" d="M23.507 0 0 13.572l23.507 13.653V0z" />
    <path
      fill="#2a3d58"
      d="m23.507 0 23.508 13.572-23.508 13.653V0zm23.508 78.231 23.507-13.572-23.507-13.652v27.224z"
    />
    <path
      fill="#0f2631"
      d="M47.015 78.231 23.507 64.659l23.508-13.652v27.224zm23.507-40.796L47.015 51.007l23.507 13.652V37.435z"
    />
    <path
      fill="#2a3d58"
      d="M70.522 37.435 94.03 51.007 70.522 64.659V37.435z"
    />
    <path fill="#0f2631" d="M23.507 37.435 0 51.007l23.507 13.652V37.435z" />
    <path
      fill="#2a3d58"
      d="m23.507 37.435 23.508 13.572-23.508 13.652V37.435z"
    />
  </svg>
);

export default Elastos;
